<script lang="ts">
	// @ts-nocheck
	//Formating
	import { format } from 'svelte-i18n';
	//Design system components
	import { ColorWheel, Radio, Select, Slider, Text, Toggle } from '@Shelly/shelly-design-system';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	import { getCurySlotOptions } from 'src/helpers/actions/local/devices/cury_local_actions';
	//Types
	import type { LocalControlOptions } from 'src/types/requests/schedules/schedules_g2';

	export let controlOption: LocalControlOptions;

	const slotOptions = getCurySlotOptions();
	const a11yProps = {
		sliderValueText: $format('current_intensity_value', {
			values: { value: controlOption.params?.intensity || 0 },
			default: `Current intensity value is ${controlOption.params?.intensity || 0}`,
		}),
		ariaLabel: $format('label_set_intensity_property', {
			default: 'Set Intensity property',
		}),
		ariaLabelValue: $format('current_intensity_value', {
			values: { value: controlOption.params?.intensity || 0 },
			default: `Current intensity value is ${controlOption.params.intensity || 0}`,
		}),
	};

	const a11yPropsSliderAmbientBrightness = {
		sliderValueText: $format('current_ambient_brightness_value', {
			values: { value: controlOption.params?.config?.ambient?.brightness || 0 },
			default: `Current ambient brightness value is ${controlOption.params?.config?.ambient?.brightness || 0}`,
		}),
		ariaLabel: $format('label_set_ambient_brightness_property', {
			default: 'Set Ambient brightness property',
		}),
		ariaLabelValue: $format('current_ambient_brightness_value', {
			values: { value: controlOption.params?.config?.ambient?.brightness || 0 },
			default: `Current ambient brightness value is ${controlOption.params?.config?.ambient?.brightness || 0}`,
		}),
	};
</script>

{#if /^cury\.(boost|set)$/.test(controlOption?.value)}
	<div>
		<Text class="mb-s mt-s" element="h2">
			{$format('label_set_slot_property', {
				default: 'Set Slot property',
			})}
		</Text>
		<Select
			id="select-2shubz3"
			size="m"
			class="mb-s"
			value={slotOptions.find((i) => i.value == controlOption.params.slot) || slotOptions[0]}
			options={slotOptions}
			icon={null}
			aria-label={$format('label_set_slot_property', {
				default: 'Set Slot property',
			})}
			on:change={(e) => {
				controlOption.params.slot = e.detail['value'];
			}}
		/>
	</div>
{/if}
{#if /^cury\.(set)$/.test(controlOption?.value)}
	<div class="d-flex flex-direction-column">
		{#if controlOption.onOffState?.selectBox}
			<Toggle
				id="toggle-gmi3m62"
				class="mb-xs"
				size="m"
				bind:checked={controlOption.onOffState.checked}
			>
				{controlOption.onOffState.label}
			</Toggle>
		{/if}

		<Radio
			id="radio-rdfg3o8"
			class="d-inline-flex mb-xs"
			value={true}
			bind:selected={controlOption.params.on}
			disabled={!controlOption.onOffState?.checked}
			size="m"
		>
			{capFirstChar($format('on_action', { default: 'on' }))}
		</Radio>
		<Radio
			id="radio-rdfg3o9"
			class="d-inline-flex mb-s"
			value={false}
			bind:selected={controlOption.params.on}
			disabled={!controlOption.onOffState?.checked}
			size="m"
		>
			{capFirstChar($format('off_action', { default: 'off' }))}
		</Radio>
	</div>
	<div>
		<Toggle id="toggle-rdfg309" class="mb-s" size="m" bind:checked={controlOption.attr.intensity}>
			{$format('label_set_intensity_property', {
				default: 'Set Intensity property',
			})}
		</Toggle>
		<Slider
			id="slider-x7i55w3"
			{a11yProps}
			type="simple"
			class="mb-s"
			value={controlOption.params.intensity || 0}
			disabled={!controlOption.attr.intensity}
			min={0}
			unit="%"
			on:value_change={(e) => {
				controlOption.params.intensity = e.detail.value;
			}}
			title={capFirstChar(
				$format('label_cover_slider_title_min_max_unit', {
					values: {
						pos: controlOption.params.intensity || 0,
						min: 0,
						max: 100,
						unit: '%',
					},
					default: 'Selected: {pos}{unit}, Range: ( {min}{unit} - {max}{unit} )',
				}),
			)}
		/>
	</div>
{/if}
{#if /^cury\.(setconfig)$/.test(controlOption?.value)}
	<div class="d-flex flex-direction-column">
		<Toggle
			id="toggle-4la26ie"
			class="mb-xs"
			size="m"
			bind:checked={controlOption.attr.config.ambient.use_vial_color}
		>
			{$format('label_set_use_vial_color_property', {
				default: 'Set Use vial color property',
			})}
		</Toggle>

		<Radio
			id="radio-rdfg3o7"
			class="d-inline-flex mb-xs"
			value={true}
			bind:selected={controlOption.params.config.ambient.use_vial_color}
			disabled={!controlOption.attr.config.ambient.use_vial_color}
			size="m"
		>
			{capFirstChar($format('on_action', { default: 'on' }))}
		</Radio>
		<Radio
			id="radio-b8oedof"
			class="d-inline-flex mb-m"
			value={false}
			bind:selected={controlOption.params.config.ambient.use_vial_color}
			disabled={!controlOption.attr.config.ambient.use_vial_color}
			size="m"
		>
			{capFirstChar($format('off_action', { default: 'off' }))}
		</Radio>
	</div>

	<div class="d-flex flex-direction-column">
		<Toggle
			class="mb-xs"
			size="m"
			bind:checked={controlOption.attr.config.ambient.enable}
			id="toggle-4la26ie"
		>
			{$format('label_set_enable_ambient_light_property', {
				default: 'Set Enable ambient light property',
			})}
		</Toggle>
		<Radio
			class="d-inline-flex mb-xs"
			value={true}
			bind:selected={controlOption.params.config.ambient.enable}
			disabled={!controlOption.attr.config.ambient.enable}
			size="m"
			id="radio-rdfg3o7"
		>
			{capFirstChar($format('on_action', { default: 'on' }))}
		</Radio>
		<Radio
			class="d-inline-flex mb-m"
			value={false}
			bind:selected={controlOption.params.config.ambient.enable}
			disabled={!controlOption.attr.config.ambient.enable}
			size="m"
			id="radio-b8oedof"
		>
			{capFirstChar($format('off_action', { default: 'off' }))}
		</Radio>
	</div>

	{#if !controlOption.params.config.ambient.use_vial_color || !controlOption.attr.config.ambient.use_vial_color}
		<div>
			<Toggle
				id="toggle-srxu9gm"
				class="mb-xs"
				size="m"
				bind:checked={controlOption.attr.config.ambient.color}
			>
				{$format('label_set_color_property', {
					default: 'Set Color property',
				})}
			</Toggle>
			<div class="d-flex justify-content-center mb-xs">
				<div style="max-width: 300px;">
					<ColorWheel
						id="colorwheel-9ayryka"
						valuesType={controlOption.attr.config.ambient.color ? 'input' : 'label'}
						color={{
							r: controlOption.params.config.ambient.color[0],
							g: controlOption.params.config.ambient.color[1],
							b: controlOption.params.config.ambient.color[2],
						}}
						class="mb-xs"
						disabled={!controlOption.attr.config.ambient.color}
						hideSaveBtn
						on:color_change={(event) => {
							const c = event.detail.color;
							controlOption.params.config.ambient.color = [c.r, c.g, c.b];
						}}
					/>
				</div>
			</div>
		</div>
	{/if}

	<div>
		<Toggle
			class="mb-xs"
			size="m"
			bind:checked={controlOption.attr.config.ambient.brightness}
			id="toggle-sozwfc0"
		>
			{$format('label_set_ambient_brightness_property', {
				default: 'Set Ambient brightness property',
			})}
		</Toggle>
		<Slider
			id="slider-5ais1bm"
			a11yProps={a11yPropsSliderAmbientBrightness}
			type="simple"
			class="mb-s"
			value={controlOption.params.config.ambient.brightness || 0}
			disabled={!controlOption.attr.config.ambient.brightness}
			min={0}
			unit="%"
			on:value_change={(e) => {
				controlOption.params.config.ambient.brightness = e.detail.value;
			}}
			title={capFirstChar(
				$format('label_cover_slider_title_min_max_unit', {
					values: {
						pos: controlOption.params.config.ambient.brightness || 0,
						min: 0,
						max: 100,
						unit: '%',
					},
					default: 'Selected: {pos}{unit}, Range: ( {min}{unit} - {max}{unit} )',
				}),
			)}
		/>
	</div>
{/if}
